import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { buildCountryOptions } from "@/lib/phone/buildCountryOptions";

export function useCountryOptions() {
  const { i18n } = useTranslation();
  return useMemo(() => buildCountryOptions(i18n.language), [i18n.language]);
}
